import { Flex } from '@components/ui/atoms/Flex';
import { AddAvatarIcon, Icon } from '@components/ui/atoms/Icons';
import { Text } from '@components/ui/atoms/Text';
import React from 'react';

interface UserAvatarProps {
  name: string;
  avatar?: string | null;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  onClick?: () => void;
}

const sizeMap = {
  xs: { container: '28px', text: '10px' },
  sm: { container: '44px', text: '16px' },
  md: { container: '64px', text: '22px' },
  lg: { container: '88px', text: '28px' },
};

export const UserAvatar: React.FC<UserAvatarProps> = ({ name, avatar, size = 'lg', onClick }) => {
  const hasName = Boolean(name?.trim());
  const hasAvatar = Boolean(avatar);

  const initials =
    hasName &&
    name!
      .split(' ')
      .map((n) => n.charAt(0))
      .join('')
      .toUpperCase();

  const { container, text } = sizeMap[size];
  const showAddIcon = !hasName && !hasAvatar;

  return (
    <Flex
      width={container}
      height={container}
      borderRadius={size === 'sm' ? '24px' : '50%'}
      alignItems="center"
      justifyContent="center"
      overflow="hidden"
      flexShrink="0"
      onClick={onClick}
      cursor={onClick ? 'pointer' : 'default'}
      css={{
        background: showAddIcon
          ? 'gray.200'
          : hasAvatar
            ? 'transparent'
            : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      }}
    >
      {hasAvatar ? (
        <img
          src={avatar!}
          alt={name || 'User Avatar'}
          style={{ width: 'full', height: 'full', objectFit: 'cover' }}
        />
      ) : hasName ? (
        <Text fontSize={text} fontWeight="600" color="body.50">
          {initials}
        </Text>
      ) : (
        <Icon
          onClick={onClick}
          css={{ width: '32px', height: '32px', flexShrink: '0', cursor: 'pointer' }}
        >
          <AddAvatarIcon />
        </Icon>
      )}
    </Flex>
  );
};
